module.exports = __webpack_public_path__ + "img/ep-O-dosis.6f112f22.jpg";